import { BLACK, WHITE } from '../../styles/colors'

import { PrimaryButton } from '../PrimaryButton/PrimaryButton'
import { BorderlessButton } from '../BorderlessButton/BorderlessButton'
import ExclamationMarkIcon from '../ExclamationMarkIcon/ExclamationMarkIcon'
import CrossIcon from '../CrossIcon/CrossIcon'
import { JagadLogo } from '../JagadLogo/JagadLogo'
import { ModalOverlay, ModalComponent, Background, CloseButtonContainer, TitleContainer, Title, Description, ActionButtonContainer, IconContainer, HelpboxContainer, HelpboxTextContainer, HelpboxTitle, HelpboxDescription, ExclamationIconContainer, CloseButton, KYCIconContainer } from './ModalWithIcon.styles'

type IconType = 'welcome' | 'void' | 'failed' | 'kyc'

export type ModalWithIconProps = {
  title: string
  description: string
  onPositive(): void
  positiveText: string
  onNegative?: () => void
  negativeText?: string
  visible?: boolean
  type: IconType
  closeButton?: boolean
  onClose?: () => void
  additionalContent?: {
    title: string
    description: string
  }
  closeIconColor?: string
  onModalOverlayClick?: () => void
  iconContainerStyle?: React.CSSProperties
}

const VoidIcon = ({
  size = 46
}: {
  size?: number
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 13.6667V23M23 32.3333H23.0233M44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23Z" stroke="url(#paint0_linear_12625_3903)" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_12625_3903" x1="-3.13158" y1="7.28947" x2="44" y2="38.3947" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3452FF" />
          <stop offset="0.56285" stopColor="#AA06E4" />
          <stop offset="1" stopColor="#E7282D" />
        </linearGradient>
      </defs>
    </svg>
  )
}

const FailedIcon = ({
  size = 46
}: {
  size?: number
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3333 27.6667L23 23M23 23L27.6667 18.3333M23 23L18.3333 18.3333M23 23L27.6667 27.6667M44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23Z"
        stroke="#E7282D"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const KYCIcon = ({
  size = 48
}) => {
  return (
    <KYCIconContainer>
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.68 30H9.5C9.10218 30 8.72064 29.842 8.43934 29.5607C8.15804 29.2794 8 28.8978 8 28.5C8 28.1022 8.15804 27.7206 8.43934 27.4393C8.72064 27.158 9.10218 27 9.5 27H17.68C18.0778 27 18.4594 27.158 18.7407 27.4393C19.022 27.7206 19.18 28.1022 19.18 28.5C19.18 28.8978 19.022 29.2794 18.7407 29.5607C18.4594 29.842 18.0778 30 17.68 30ZM16.5 36H9.5C9.10218 36 8.72064 35.842 8.43934 35.5607C8.15804 35.2794 8 34.8978 8 34.5C8 34.1022 8.15804 33.7206 8.43934 33.4393C8.72064 33.158 9.10218 33 9.5 33H16.5C16.8978 33 17.2794 33.158 17.5607 33.4393C17.842 33.7206 18 34.1022 18 34.5C18 34.8978 17.842 35.2794 17.5607 35.5607C17.2794 35.842 16.8978 36 16.5 36Z" fill="white" />
        <path d="M16.5 42H5.5C4.04164 41.9989 2.6433 41.4191 1.61208 40.3879C0.580862 39.3567 0.00105947 37.9584 0 36.5L0 5.5C0.00105947 4.04163 0.580862 2.6433 1.61208 1.61208C2.6433 0.580862 4.04164 0.00105947 5.5 0L28.5 0C29.9584 0.00105947 31.3567 0.580862 32.3879 1.61208C33.4191 2.6433 33.9989 4.04163 34 5.5V16.62C34 17.0178 33.842 17.3994 33.5607 17.6807C33.2794 17.962 32.8978 18.12 32.5 18.12C32.1022 18.12 31.7206 17.962 31.4393 17.6807C31.158 17.3994 31 17.0178 31 16.62V5.5C31 4.122 29.878 3 28.5 3H5.5C4.122 3 3 4.122 3 5.5V36.5C3 37.878 4.122 39 5.5 39H16.5C16.8978 39 17.2794 39.158 17.5607 39.4393C17.842 39.7206 18 40.1022 18 40.5C18 40.8978 17.842 41.2794 17.5607 41.5607C17.2794 41.842 16.8978 42 16.5 42Z" fill="white" />
        <path d="M17 14C19.2091 14 21 12.2091 21 10C21 7.79086 19.2091 6 17 6C14.7909 6 13 7.79086 13 10C13 12.2091 14.7909 14 17 14Z" fill="white" />
        <path d="M23.5 24.0001H10.5C10.1022 24.0001 9.72064 23.8421 9.43934 23.5608C9.15804 23.2795 9 22.8979 9 22.5001V21.5001C9.00106 20.0418 9.58086 18.6434 10.6121 17.6122C11.6433 16.581 13.0416 16.0012 14.5 16.0001H19.5C20.9584 16.0012 22.3567 16.581 23.3879 17.6122C24.4191 18.6434 24.9989 20.0418 25 21.5001V22.5001C25 22.8979 24.842 23.2795 24.5607 23.5608C24.2794 23.8421 23.8978 24.0001 23.5 24.0001ZM35 22.0001C27.832 22.0001 22 27.8321 22 35.0001C22 42.1681 27.832 48.0001 35 48.0001C42.168 48.0001 48 42.1681 48 35.0001C48 27.8321 42.168 22.0001 35 22.0001ZM41.504 31.8181L34.504 39.8181C34.3236 40.0239 34.1029 40.1905 33.8555 40.3076C33.6081 40.4246 33.3393 40.4897 33.0658 40.4987C32.7923 40.5077 32.5198 40.4604 32.2653 40.3599C32.0107 40.2593 31.7795 40.1076 31.586 39.9141L27.586 35.9141C27.4003 35.7284 27.253 35.508 27.1525 35.2654C27.052 35.0228 27.0003 34.7627 27.0003 34.5001C27.0003 34.2375 27.052 33.9775 27.1525 33.7349C27.253 33.4923 27.4003 33.2718 27.586 33.0861C27.7717 32.9004 27.9921 32.7531 28.2347 32.6526C28.4774 32.5521 28.7374 32.5004 29 32.5004C29.2626 32.5004 29.5226 32.5521 29.7653 32.6526C30.0079 32.7531 30.2283 32.9004 30.414 33.0861L32.902 35.5741L38.494 29.1821C38.8497 28.806 39.3373 28.5822 39.8545 28.5579C40.3716 28.5336 40.8781 28.7105 41.2676 29.0516C41.657 29.3927 41.8992 29.8714 41.9433 30.3872C41.9874 30.903 41.8299 31.4159 41.504 31.8181Z" fill="white" />
      </svg>
    </KYCIconContainer>
  )
}

const ModalIcon = ({ type }: { type: IconType }) => {
  switch (type) {
    case 'welcome':
      return <JagadLogo type="logo-circular" size={36} />;
    case 'void':
      return <VoidIcon />;
    case 'failed':
      return <FailedIcon size={36} />;
    case 'kyc':
      return <KYCIcon />
  }
}

export const ModalWithIcon = ({
  title,
  description,
  onPositive,
  positiveText,
  onNegative,
  negativeText,
  visible,
  type,
  closeButton = false,
  onClose,
  additionalContent,
  closeIconColor = WHITE,
  onModalOverlayClick,
  iconContainerStyle
}: ModalWithIconProps) => {
  if (!visible) return null

  const handleModalContentClick = (e: React.MouseEvent) => {
    if (onModalOverlayClick) {
      onModalOverlayClick()
    } else {
      // Stop the event from propagating to the overlay
      e.stopPropagation()
    }
  }

  return (
    <ModalOverlay onClick={onClose}>
      <ModalComponent onClick={handleModalContentClick}>
        <Background>
          {closeButton && <CloseButtonContainer>
            <CloseButton onClick={onClose}>
              <CrossIcon size={12} color={closeIconColor} thickness={2} />
            </CloseButton>
          </CloseButtonContainer>}
          <IconContainer style={iconContainerStyle}>
            <ModalIcon type={type} />
          </IconContainer>
          <TitleContainer>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </TitleContainer>

          {additionalContent && <HelpboxContainer>
            <ExclamationIconContainer>
              <ExclamationMarkIcon width={18} height={18} outline={BLACK} exclamationColor={BLACK} />
            </ExclamationIconContainer>
            <HelpboxTextContainer>
              <HelpboxTitle>{additionalContent.title}</HelpboxTitle>
              <HelpboxDescription>
                {additionalContent.description}
              </HelpboxDescription>
            </HelpboxTextContainer>
          </HelpboxContainer>}

          <ActionButtonContainer $hasNegativeButton={!!onNegative && !!negativeText}>
            <PrimaryButton
              onClick={onPositive}
            >
              {positiveText}
            </PrimaryButton>
            {onNegative && <BorderlessButton onClick={onNegative}>
              {negativeText}
            </BorderlessButton>}
          </ActionButtonContainer>
        </Background>
      </ModalComponent>
    </ModalOverlay>
  )
}

export default ModalWithIcon
